/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Modal, Spin, message, Tag, Typography } from 'antd';
import { SearchOutlined, RollbackOutlined ,ExclamationCircleOutlined } from '@ant-design/icons';
import { hnrequest } from '@/utils'
import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';

const { Paragraph, Text } = Typography;
const Dbdel = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [tdown] = Form.useForm();
  const [spinning, setSpinning] = useState(false);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息

  const [open, setOpen] = useState(false);
  const [bangm, setbangm] = useState([]);
  const [ticks, setticks] = useState([]);// 选择的产品信息



  const toDown = async (e) => { // 数据下单
    setSpinning(true)
    setOpen(false)
    const dbd = await hnrequest.post('/pdbdelCancel', e)
    if (dbd.return_code) { setSpinning(false) }
    setticks(dbd.ticks)
    messageApi.open({ type: dbd.return_code, content: dbd.return_msg, });
    // dbd.return_code==="success" && setbangm(bangm.filter(item => item.key !== e.dbno))
  }


  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/pdb_list', { dbzt: 'ddel', ticks: ticks })
      setbangm(res.rescode)
    
    }

    getau()


  }, [ticks])


  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const ppth = (e) => {
    setOpen(true)
    setccpxx(e)
    tdown.setFieldsValue({ dbno: e.key })

  }


  const columns = [
    {
      title: '',
      dataIndex: 'key',
      key: 'key',
      render: (_, record) => (<Space><Button type="primary" icon={<RollbackOutlined />} onClick={() => ppth(record, "o")} />


      </Space>

      ),
    },

    {
      title: '数据批号',
      dataIndex: 'key',
      key: 'key',
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },

    {
      title: '申请时间',
      dataIndex: 'dstime',
      key: 'dstime',
      ...getColumnSearchProps('dstime'),
    },
    {
      title: '类型',
      dataIndex: 'plb',
      key: 'plb',
      render: (_, record) => (
        <Space size="small">
          {record.dblx === "outdb" && <Tag color="#108ee9" >Group</Tag>}
          {record.dblx === "indb" && <Tag color="#87d068" >Single</Tag>}
          {record.plb === "1001" && <Tag color="volcano" >农药</Tag>}
          {record.plb === "1003" && <Tag color="green" >种子</Tag>}
          {record.plb === "1002" && <Tag color="purple" >农肥&其他</Tag>}
          {record.plb === "1004" && <Tag color="purple" >农肥&其他</Tag>}
        </Space>
      ),
    },
    {
      title: '产品名称',
      key: 'pname',
      ...getColumnSearchProps('pname'),
      dataIndex: 'pname',


    },
    {
      title: '生成时间',
      dataIndex: 'scsj',
      key: 'scsj',
      ...getColumnSearchProps('scsj'),
    },
    {
      title: '数量',
      dataIndex: 'db_total',
      key: 'db_total',
    },

  ];
  return (
    <>


      <ConfigProvider locale={zhCN} >
        {contextHolder}
        <Tag icon={<ExclamationCircleOutlined  />} color="error"> 回收站数据在加入删除序列起30天内可以撤回，30天后由系统统一自动删除。</Tag>
 
          <Table size="small"
            // rowSelection={   {type:"checkbox",...rowSelection,}} 
            columns={columns} dataSource={bangm} />

      



        <Modal
          // title="数据信息"
          centered
          open={open}
          footer={false}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
        >
          <Form form={tdown} onFinish={toDown}>

            <Paragraph>产品名称:{ccpxx.pname}  <Text>数据批号:{ccpxx.key}</Text> </Paragraph>

            <Form.Item name="dbno" hidden="true"><Input /></Form.Item>





            <Form.Item >
              <Button type="primary" htmlType="submit" block>
                撤回删除
              </Button>
            </Form.Item>

          </Form>




        </Modal>





        <Spin spinning={spinning} description="数据整理中，请稍等..." fullscreen />

      </ConfigProvider>
    </>

  );
};
export default Dbdel;